import { GetBankBranchOfficesQuery } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const getBankBranchOfficesHandler =
  graphql.query<GetBankBranchOfficesQuery>(
    "getBankBranchOffices",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          bankBranchOffices: [
            {
              bankId: 9999,
              branchOfficeCode: "001",
              branchOfficeId: 1,
              branchOfficeName: "本店",
              isHeadOfficeOn: true,
            },
            {
              bankId: 9999,
              branchOfficeCode: "002",
              branchOfficeId: 2,
              branchOfficeName: "A支店",
              isHeadOfficeOn: false,
            },
            {
              bankId: 9999,
              branchOfficeCode: "003",
              branchOfficeId: 3,
              branchOfficeName: "B支店",
              isHeadOfficeOn: false,
            },
            {
              bankId: 9999,
              branchOfficeCode: "004",
              branchOfficeId: 4,
              branchOfficeName: "C支店",
              isHeadOfficeOn: false,
            },
          ],
        },
      });
    }
  );
